<div class="flex flex-col gap-4">
  <!-- Mode toggle: sell a saved template package vs an ad-hoc bundle (beaut-367) -->
  <nz-segmented
    class="self-start"
    [nzOptions]="modeOptions"
    [ngModel]="mode()"
    (ngModelChange)="onModeChange($any($event))"
  ></nz-segmented>

  <!-- Gift: buy for another customer (beaut-251) -->
  <div class="flex flex-col gap-2">
    <label
      nz-checkbox
      [ngModel]="isGift()"
      (ngModelChange)="toggleGift($event)"
    >
      {{ 'services.packages.buyForAnother' | translate }}
    </label>
    @if (isGift()) {
    <div class="flex items-start gap-2">
      <beautyapp-select-search
        class="min-w-0 flex-1"
        [formControl]="beneficiaryId"
        [placeholder]="'services.packages.selectBeneficiary' | translate"
        [data]="beneficiaries()"
        displayMember="name"
        valueMember="id"
        (onSearch)="onBeneficiarySearch($event)"
      ></beautyapp-select-search>
      <button
        type="button"
        nz-button
        nzType="primary"
        nzShape="circle"
        [title]="'calendar.createUser' | translate"
        (click)="addNewBeneficiary()"
      >
        <i nz-icon nzType="user-add" nzTheme="outline"></i>
      </button>
    </div>
    }
  </div>

  <!-- Step 1: Pick a package (template mode) -->
  @if (mode() === 'template') {
  <div>
    <div class="text-sm font-semibold text-gray-800 mb-2">აირჩიეთ პაკეტი:</div>

    <!-- Server-side search: debounced FormControl → rxResource → /service-packages?q=… -->
    <div class="mb-2">
      <input
        nz-input
        type="text"
        placeholder="ძებნა პაკეტის ან სერვისის სახელით..."
        [formControl]="searchControl"
      />
    </div>

    <nz-spin [nzSpinning]="loadingPackages()">
      @if (packages().length === 0 && !loadingPackages() && !hasSearchTerm()) {
      <nz-alert
        nzType="info"
        [nzMessage]="'services.packages.noActivePackage' | translate"
        [nzDescription]="
          'services.packages.noActivePackageDescription' | translate
        "
      />
      } @else if (packages().length === 0 && !loadingPackages() &&
      hasSearchTerm()) {
      <nz-alert
        nzType="info"
        [nzMessage]="
          'services.packages.noPackagesForSearch'
            | translate : { term: searchTerm() }
        "
      />
      } @else {
      <nz-table
        [nzData]="packages()"
        [nzFrontPagination]="false"
        [nzTotal]="total()"
        [nzPageIndex]="page()"
        [nzPageSize]="pageSize()"
        [nzPageSizeOptions]="[5, 10, 20, 50]"
        nzShowSizeChanger
        (nzQueryParams)="onTableChange($event)"
        nzSize="small"
      >
        <thead>
          <tr>
            <th>დასახელება</th>
            <th nzWidth="96px" class="text-center">ვადა (დღე)</th>
            <th nzWidth="104px" class="text-right">ფასი</th>
            <th nzWidth="96px" class="transaction-delete-td"></th>
          </tr>
        </thead>
        <tbody>
          @for (pkg of packages(); track pkg.id) {
          <tr
            [class.bg-primary-50]="selected()?.id === pkg.id"
            class="cursor-pointer transition-colors"
            (click)="selectPackage(pkg)"
          >
            <td>
              <div class="font-medium">{{ pkg.name }}</div>
              @if (pkg.items?.length) {
              <div class="flex flex-wrap gap-1 mt-1">
                @for (item of pkg.items; track item.id) {
                <nz-tag nzColor="cyan" class="text-xs">
                  {{ item.serviceName || '—' }}
                  <span class="font-bold ml-1">×{{ item.quantity }}</span>
                </nz-tag>
                }
              </div>
              }
            </td>
            <td class="text-center tabular-nums">{{ pkg.validityDays }}</td>
            <td class="text-right tabular-nums font-medium">
              {{ +pkg.price }} ₾
            </td>
            <td class="text-right">
              @if (selected()?.id === pkg.id) {
              <nz-tag nzColor="green">არჩეული</nz-tag>
              } @else {
              <button
                nz-button
                nzType="primary"
                nzSize="small"
                type="button"
                (click)="$event.stopPropagation(); selectPackage(pkg)"
              >
                არჩევა
                <nz-icon nzType="right" nzTheme="outline" />
              </button>
              }
            </td>
          </tr>
          }
        </tbody>
      </nz-table>
      }
    </nz-spin>
  </div>
  }

  <!-- Ad-hoc bundle builder (ad-hoc mode) (beaut-367) -->
  @if (mode() === 'adHoc') {
  <div>
    <div class="flex items-center justify-between mb-3">
      <div class="text-sm font-semibold text-gray-800">
        {{ 'services.packages.adHocBundle' | translate }}
      </div>
      <button
        nz-button
        nzType="dashed"
        nzSize="small"
        type="button"
        (click)="addBundleRow()"
      >
        <nz-icon nzType="plus" nzTheme="outline" />
        {{ 'services.packages.addProcedure' | translate }}
      </button>
    </div>

    @if (bundle.length === 0) {
    <div
      class="flex flex-col items-center justify-center gap-2 py-9 text-center border border-dashed border-gray-200 rounded-xl"
    >
      <span
        nz-icon
        nzType="inbox"
        nzTheme="outline"
        class="text-2xl text-gray-300"
      ></span>
      <div class="text-sm text-gray-400 max-w-[240px]">
        {{ 'services.packages.noProcedures' | translate }}
      </div>
    </div>
    } @else {
    <!-- Column labels (match the package-create form: name, qty, original,
         discount %, discounted price) -->
    <div
      class="hidden md:grid grid-cols-[minmax(0,1fr)_60px_96px_80px_100px_32px] gap-2 px-1 pb-1.5 text-[11px] font-medium uppercase tracking-wide text-gray-400"
    >
      <span>{{ 'servicePackages.form.serviceName' | translate }}</span>
      <span class="text-center">{{
        'servicePackages.form.quantity' | translate
      }}</span>
      <span class="text-right">{{
        'servicePackages.form.originalPrice' | translate
      }}</span>
      <span class="text-center">{{
        'servicePackages.form.discountPercent' | translate
      }}</span>
      <span class="text-right">{{
        'servicePackages.form.discountedPrice' | translate
      }}</span>
      <span></span>
    </div>

    <div class="flex flex-col gap-1.5">
      @for (row of bundle.controls; track $index; let i = $index) {
      <div
        class="grid grid-cols-2 md:grid-cols-[minmax(0,1fr)_60px_96px_80px_100px_32px] gap-2 items-center"
        [formGroup]="$any(row)"
      >
        <beautyapp-select
          class="col-span-2 md:col-span-1"
          formControlName="serviceId"
          [placeholder]="'servicePackages.form.selectService' | translate"
          [data]="services()"
          displayMember="name"
          valueMember="id"
          (selected)="onBundleServiceSelect(i, $event)"
        />
        <nz-input-number
          formControlName="quantity"
          [nzMin]="1"
          [nzStep]="1"
          class="w-full"
        ></nz-input-number>
        <nz-input-number
          formControlName="originalPrice"
          [nzMin]="0"
          [nzStep]="1"
          [nzPrecision]="2"
          class="w-full"
          (ngModelChange)="onBundleOriginalPriceChange(i)"
        ></nz-input-number>
        <nz-input-number
          formControlName="discountPercent"
          [nzMin]="0"
          [nzMax]="100"
          [nzStep]="1"
          class="w-full"
          [nzFormatter]="percentFormatter"
          [nzParser]="percentParser"
          (ngModelChange)="onBundleDiscountPercentChange(i)"
        ></nz-input-number>
        <nz-input-number
          formControlName="discountedPrice"
          [nzMin]="0"
          [nzStep]="1"
          [nzPrecision]="2"
          class="w-full"
          (ngModelChange)="onBundleDiscountedPriceChange(i)"
        ></nz-input-number>
        <button
          class="justify-self-center text-gray-400 hover:text-red-500"
          nz-button
          nzType="text"
          nzSize="small"
          type="button"
          [attr.aria-label]="'buttons.delete' | translate"
          (click)="removeBundleRow(i)"
        >
          <span nz-icon nzType="delete" nzTheme="outline"></span>
        </button>
      </div>
      }
    </div>

    <!-- Bundle total: the headline number in ad-hoc mode. Pre-discount total is
         shown struck-through when a discount is applied. -->
    <div
      class="flex items-baseline justify-between mt-3 pt-3 border-t border-gray-100"
    >
      <span class="text-sm text-gray-500">{{
        'services.packages.total' | translate
      }}</span>
      <span class="flex items-baseline gap-2">
        @if (adHocHasDiscount()) {
        <span class="text-sm text-gray-400 line-through tabular-nums">
          {{ adHocOriginalTotal() | number : '1.2-2' }} ₾
        </span>
        }
        <span class="text-lg font-semibold text-primary-600 tabular-nums">
          {{ adHocTotal() | number : '1.2-2' }} ₾
        </span>
      </span>
    </div>
    }

    <!-- Validity window -->
    <div class="mt-4 max-w-[220px]">
      <label
        class="block text-[11px] font-medium uppercase tracking-wide text-gray-400 mb-1"
        >{{ 'services.packages.validityDays' | translate }}</label
      >
      <nz-input-number
        [formControl]="validityDays"
        [nzMin]="1"
        [nzStep]="1"
        class="w-full"
      ></nz-input-number>
    </div>

    <!-- Save the bundle as a reusable catalog template (beaut-362) -->
    <div class="mt-3 flex flex-col gap-2">
      <label
        nz-checkbox
        [ngModel]="saveAsTemplate()"
        (ngModelChange)="toggleSaveAsTemplate($event)"
      >
        {{ 'services.packages.saveToTemplates' | translate }}
      </label>
      @if (saveAsTemplate()) {
      <!-- beaut-383: bare nz-input has no built-in error styling, so bind
           nzStatus to the touched+invalid state so the required name field
           turns red when the user clicks Save without filling it. -->
      <input
        nz-input
        [formControl]="templateName"
        [nzStatus]="templateName.invalid && templateName.touched ? 'error' : ''"
        [placeholder]="'services.packages.templateName' | translate"
        class="max-w-[320px]"
      />
      @if (templateName.invalid && templateName.touched) {
      <span class="text-red-500 text-xs">
        {{ 'services.packages.templateNameRequired' | translate }}
      </span>
      }
      }
    </div>
  </div>
  }

  <!-- Step 2: Payment details (once there is something to pay for) -->
  @if (showPayment()) {
  <div class="border-t pt-4">
    @if (mode() === 'template' && selected(); as pkg) {
    <div class="flex justify-between items-center mb-3">
      <div>
        <div class="text-sm font-semibold text-gray-800">{{ pkg.name }}</div>
        <div class="text-xs text-gray-500 tabular-nums">
          {{ pkg.validityDays }} დღე · {{ +pkg.price }} ₾
        </div>
      </div>
      <button
        nz-button
        nzType="default"
        nzSize="small"
        type="button"
        (click)="clearSelection()"
      >
        <nz-icon nzType="close" nzTheme="outline" />
        შეცვლა
      </button>
    </div>
    } @else {
    <div class="flex items-baseline justify-between mb-3">
      <span class="text-sm font-semibold text-gray-800">{{
        'services.packages.adHocBundle' | translate
      }}</span>
      <span class="text-base font-semibold text-primary-600 tabular-nums">
        {{ adHocTotal() | number : '1.2-2' }} ₾
      </span>
    </div>
    }

    <!-- Customer wallet balance preview. Red when below effectivePrice so the
           operator sees at a glance whether BALANCE payment is viable. -->
    @if (selectedBalance() !== null) {
    <div class="text-xs text-gray-500 mb-2">
      {{ 'PAYMENTTYPE.5' | translate }}:
      <span
        class="font-medium tabular-nums"
        [class.text-red-500]="
          balanceRelevant && selectedBalance()! < effectivePrice
        "
        [class.text-green-600]="
          balanceRelevant && selectedBalance()! >= effectivePrice
        "
      >
        {{ selectedBalance() | number : '1.2-2' }} ₾
      </span>
    </div>
    }

    <form [formGroup]="form" class="flex flex-col gap-3">
      <beautyapp-select
        formControlName="paymentMethod"
        [label]="'servicePackages.sellModal.paymentMethod' | translate"
        [data]="paymentMethods"
        displayMember="label"
        valueMember="value"
      ></beautyapp-select>

      <!-- CASH: display-only amount (backend auto-fills from package price) -->
      @if (selectedMethod === 'CASH') {
      <div>
        <label class="text-xs text-gray-500 block mb-1">{{
          'PAYMENTTYPE.1' | translate
        }}</label>
        <div class="relative">
          <span class="absolute left-2 top-1/2 -translate-y-1/2">₾</span>
          <input
            type="number"
            class="w-full border rounded px-6 py-2 bg-gray-100 cursor-not-allowed"
            [value]="effectivePrice"
            disabled
          />
        </div>
      </div>
      }

      <!-- CARD: card + bank select -->
      @if (selectedMethod === 'CARD') {
      <div class="flex gap-3">
        <beautyapp-input
          formControlName="card"
          [label]="'PAYMENTTYPE.2' | translate"
          type="number"
          prefix="₾"
        ></beautyapp-input>
        <beautyapp-select
          formControlName="bank"
          [label]="'calendar.form.paymentMethod' | translate"
          [data]="banks"
          displayMember="name"
          valueMember="id"
        ></beautyapp-select>
      </div>
      }

      <!-- MIXED: cash + card + bank + balance + bankTransfer + bankTransferBank -->
      @if (selectedMethod === 'MIXED') {
      <beautyapp-input
        formControlName="cash"
        [label]="'PAYMENTTYPE.1' | translate"
        type="number"
        prefix="₾"
      ></beautyapp-input>
      <div class="flex gap-3">
        <beautyapp-input
          formControlName="card"
          [label]="'PAYMENTTYPE.2' | translate"
          type="number"
          prefix="₾"
        ></beautyapp-input>
        <beautyapp-select
          formControlName="bank"
          [label]="'calendar.form.paymentMethod' | translate"
          [data]="banks"
          displayMember="name"
          valueMember="id"
        ></beautyapp-select>
      </div>
      <beautyapp-input
        formControlName="balance"
        [label]="'PAYMENTTYPE.5' | translate"
        type="number"
        prefix="₾"
      ></beautyapp-input>
      <div class="flex gap-3">
        <beautyapp-input
          formControlName="bankTransfer"
          [label]="'PAYMENTTYPE.8' | translate"
          type="number"
          prefix="₾"
        ></beautyapp-input>
        <beautyapp-select
          formControlName="bankTransferBank"
          [label]="'calendar.form.paymentMethod' | translate"
          [data]="banks"
          displayMember="name"
          valueMember="id"
        ></beautyapp-select>
      </div>
      }

      <!-- BALANCE: display-only amount (backend debits from user wallet) -->
      @if (selectedMethod === 'BALANCE') {
      <div>
        <label class="text-xs text-gray-500 block mb-1">{{
          'PAYMENTTYPE.5' | translate
        }}</label>
        <div class="relative">
          <span class="absolute left-2 top-1/2 -translate-y-1/2">₾</span>
          <input
            type="number"
            class="w-full border rounded px-6 py-2 bg-gray-100 cursor-not-allowed"
            [value]="effectivePrice"
            disabled
          />
        </div>
      </div>
      }

      <!-- BARTER: no extra fields -->

      <!-- CONSIGNATION: cash + card + bank + consignation -->
      @if (selectedMethod === 'CONSIGNATION') {
      <beautyapp-input
        formControlName="cash"
        [label]="'PAYMENTTYPE.1' | translate"
        type="number"
        prefix="₾"
      ></beautyapp-input>
      <div class="flex gap-3">
        <beautyapp-input
          formControlName="card"
          [label]="'PAYMENTTYPE.2' | translate"
          type="number"
          prefix="₾"
        ></beautyapp-input>
        <beautyapp-select
          formControlName="bank"
          [label]="'calendar.form.paymentMethod' | translate"
          [data]="banks"
          displayMember="name"
          valueMember="id"
        ></beautyapp-select>
      </div>
      <beautyapp-input
        formControlName="consignation"
        [label]="'PAYMENTTYPE.7' | translate"
        type="number"
        prefix="₾"
      ></beautyapp-input>
      }

      <!-- BANK_TRANSFER: bankTransfer + bankTransferBank -->
      @if (selectedMethod === 'BANK_TRANSFER') {
      <div class="flex gap-3">
        <beautyapp-input
          formControlName="bankTransfer"
          [label]="'PAYMENTTYPE.8' | translate"
          type="number"
          prefix="₾"
        ></beautyapp-input>
        <beautyapp-select
          formControlName="bankTransferBank"
          [label]="'calendar.form.paymentMethod' | translate"
          [data]="banks"
          displayMember="name"
          valueMember="id"
        ></beautyapp-select>
      </div>
      }

      <div>
        <div class="text-xs mb-1">კომენტარი (არასავალდებულო)</div>
        <textarea
          nz-input
          formControlName="comment"
          rows="2"
          placeholder="მაგ. დასაშვები ფასდაკლება"
        ></textarea>
      </div>
    </form>
  </div>
  }

  <!-- Payment-sum mismatch (beaut-219): entered channels must equal the price -->
  @if (showPayment() && form.errors?.['paymentSumMismatch']; as e) {
  <nz-alert
    class="block mb-2"
    nzType="error"
    nzShowIcon
    [nzMessage]="
      ('servicePackages.sellModal.paymentSumMismatch' | translate) +
      ': ' +
      effectivePrice +
      ' ₾'
    "
  ></nz-alert>
  }

  <!-- Footer actions -->
  <div class="flex justify-end gap-2 pt-3 border-t">
    <button
      nz-button
      nzType="default"
      type="button"
      (click)="cancel()"
      [disabled]="submitting()"
    >
      გაუქმება
    </button>
    <button
      nz-button
      nzType="primary"
      type="button"
      (click)="submit()"
      [nzLoading]="submitting()"
      [disabled]="!canSubmit()"
    >
      შეძენა
    </button>
  </div>
</div>
